import { watchCreateArticlePage } from './watchCreateArticlePage';
import { watchUpdateStatusArticlePage } from './watchUpdateStatusArticlePage';
import { watchDeleteArticlePages } from './watchDeleteArticlePages';
import { watchGetArticlePages } from './watchGetArticlePages';
import { watchLoadMoreArticlePages } from './watchLoadMore';
import { watchDuplicateArticlePage } from 'containers/Admin/PageBuilder/ArticlesPage/store/sagas/watchDuplicateArticlePage';

export const sagasArticlePage = [
  watchCreateArticlePage,
  watchUpdateStatusArticlePage,
  watchDeleteArticlePages,
  watchGetArticlePages,
  watchLoadMoreArticlePages,
  watchDuplicateArticlePage,
];
